import { State } from '../../store.types'

export const selectDesktopState = (state: State) => state.desktop
